import { gql } from "@/__generated__/gql";

export const COMMUNITY_GROWTH_TIME_SERIES = gql(`
  query CommunityGrowth(
    $orgId: ID!
    $startDate: Date!
    $endDate: Date!
    $cohortYear: Int!
    $inCommunity: YesNoEnum!
  ) {
    node(id: $orgId) {
      ... on Organization {
        id
        studentListTimeSeries(
          argument: {
            communityGrowth: {
              dateRange: { start: $startDate, inclusiveEnd: $endDate }
              filters: { cohortYear: [$cohortYear], inCommunity: $inCommunity }
            }
          }
        ) {
          date
          value
        }
      }
    }
  }`);
